import { Layouts } from "react-grid-layout";
import {
  widgetActionSummary,
  widgetAnalytics,
  widgetAxeCreation,
  widgetPrice,
  widgetSwapCurve,
  widgetTradeCreation,
  widgetTradeFromScratch,
  widgetTradeTile,
} from "../components/icons/SVGIcons";

// --- interfaces for fetch requests and setting state, mainly used in the index and store files -- //

export interface IActiveTabData {
  tabId: number;
  active: boolean;
  displayName: string;
}

export interface IFullWorkSpaceTab {
  tabId: number;
  active: boolean;
  displayName: string;
  stateJson: any;
}

export interface IWorkspaceTabs {
  tabId: number;
  stateJson: string;
}

// --- Controlled by RGL lib, anything in addition to what is on here will be removed by RGL lib --- //
// -- for IState . layouts -- //
// export interface IRGLWidgetDetails {
//   w: number;
//   h: number;
//   x: number;
//   y: number;
//   i: string;
//   minW?: number;
//   maxW?: number;
//   minH?: number;
//   maxH?: number;
//   moved?: boolean;
//   static?: boolean;
//   isDraggable?: boolean;
//   isResizable?: boolean;
//   resizeHandles?: string[];
//   isBounded?: boolean;
//   // These will be added in some functions but when a breakpoint is changed, the RGL lib will cut them off along with any props that it is not expecting.
//   // displayName?: string;
//   // component?: string;
// }

//----------List of widgets details to create widgets ---------- //
// -- for IState . openWidgets -- //

export interface IbaseWidgetDetails {
  displayName: string;
  component: string;
  icon?: string | JSX.Element;
  w: number;
  h: number;
  // minW/minH are mandatory: RGL defaults them to 1, which lets a widget be
  // dragged down to a bare header. See applyMinSizesToLayouts.
  minW: number;
  minH: number;
  activePricesConfigIdNumber?: number;
  activeAnalyticsConfigIdNumber?: number;
}

export interface IWidgetDetails extends IbaseWidgetDetails {
  y: number;
  x: number;
  i: string;
  // TO DO - How can we avoid needing to outline all of the possible data that is used in the widget. Should there be an interface for each of the widgets that extends from this so it shows what data we are wanting to collect on that widget?
  // Remove any from the following 3 types.
  columnSizes?: any;
  columnOrder?: any;
  columnVisibility?: any;
  esid?: any; // should be a string - will not always be on the widgets.
}

export interface ICols {
  [key: string]: number;
}

// This is the main data that is used to render in the DOM. The open widgets are provided outside of the RGL lib.
export interface IState {
  currentBreakpoint: string;
  compactType: "vertical" | "horizontal" | null | undefined;
  mounted: boolean;
  layouts: Layouts;
  cols: ICols;
  openWidgets: IWidgetDetails[];
}

export const baseWidgetDetails: IbaseWidgetDetails[] = [
  {
    displayName: "Trade Blotter",
    component: "ActionSummary",
    icon: widgetActionSummary,
    w: 12,
    h: 10,
    minW: 3,
    minH: 5,
  },
  {
    displayName: "Trade Creation",
    component: "TradeCreation",
    icon: widgetTradeCreation,
    w: 6,
    h: 10,
    minW: 3,
    minH: 5,
  },
  // LQC-2254 - the component key is fixed ("TradeFromScratch" is what the API sends); the
  // displayName is free to change (WidgetHeader resolves the label by component key, so no
  // migration). See widgets/tradeFromScratch/README.md.
  {
    displayName: "Leg Creation",
    component: "TradeFromScratch",
    icon: widgetTradeFromScratch,
    w: 4,
    h: 10,
    minW: 3,
    minH: 5,
  },
  {
    displayName: "Trade Tile",
    component: "TradeTile",
    icon: widgetTradeTile,
    w: 6,
    h: 8,
    minW: 3,
    minH: 5,
  },
  {
    displayName: "Prices",
    component: "Price",
    icon: widgetPrice,
    w: 12,
    h: 8,
    minW: 4,
    minH: 5,
    activePricesConfigIdNumber: -1,
  },
  {
    displayName: "Analytics",
    component: "Analytics",
    icon: widgetAnalytics,
    w: 6,
    h: 12,
    minW: 6,
    minH: 8,
    activeAnalyticsConfigIdNumber: -1,
  },
  {
    displayName: "Swap Curve",
    component: "SwapCurve",
    icon: widgetSwapCurve,
    w: 6,
    h: 10,
    minW: 3,
    minH: 5,
  },
  {
    displayName: "Axe Blotter",
    component: "AxeCreation",
    icon: widgetAxeCreation,
    w: 12,
    h: 10,
    minW: 3,
    minH: 5,
  },
];

// Used in RGL and GenerateAllWidgets
export interface IActiveId {
  isActive: boolean; // used to set the CSS
  value: string | null; // pass the info here (the drag payload — e.g. esid or block id).
  headerDragging: string | null; // to process logic of which widgets can interact with this drag object.
  eventOver: string; // Store the ID that was interacted with in order to update it.
  label?: string | null; // optional display text for the drag overlay (defaults to value).
}
